var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Dialog, DialogActions, DialogContent, dialogTitleClasses } from "@mui/material";
import { TruffleDialogTitle } from "../../../MuiComponents/Dialog/TruffleDialogTitle";
import { combineSxProps, scrollOnHoverSxProps } from "../../../Utils";
export const TabbedDialog = (_a) => {
    var { open, title, leftSlot, LeftSlotProps, CloseIconButtonProps, HelpCenterIconButtonProps, dialogActions, DialogActionsProps, DialogContentProps, rightSlot } = _a, dialogProps = __rest(_a, ["open", "title", "leftSlot", "LeftSlotProps", "CloseIconButtonProps", "HelpCenterIconButtonProps", "dialogActions", "DialogActionsProps", "DialogContentProps", "rightSlot"]);
    const _b = LeftSlotProps || {}, { sx: leftSlotSxProp } = _b, leftSlotProps = __rest(_b, ["sx"]);
    const _c = DialogContentProps || {}, { sx: dialogContentSxProps } = _c, dialogContentProps = __rest(_c, ["sx"]);
    return (_jsx(Dialog, Object.assign({ open: open }, dialogProps, { children: _jsxs(Box, { sx: contentSxProps, children: [_jsx(Box, Object.assign({ sx: combineSxProps(Object.assign(Object.assign({}, scrollOnHoverSxProps), { minWidth: "177px", padding: "16px 0 16px 12px", overflowY: "auto" }), leftSlotSxProp) }, leftSlotProps, { children: leftSlot })), _jsxs(Box, { sx: rightSlotSxProps, children: [_jsx(TruffleDialogTitle, { CloseIconButtonProps: CloseIconButtonProps, HelpCenterIconButtonProps: HelpCenterIconButtonProps, sx: { padding: "14px 12px 0 16px" }, children: title }), _jsx(DialogContent, Object.assign({ sx: combineSxProps({ [`.${dialogTitleClasses.root} + &`]: { padding: "16px" } }, dialogContentSxProps) }, dialogContentProps, { children: rightSlot })), dialogActions && _jsx(DialogActions, Object.assign({ sx: { padding: "0 16px 16px 16px" } }, DialogActionsProps, { children: dialogActions }))] })] }) })));
};
const contentSxProps = {
    display: "flex",
    backgroundColor: (theme) => theme.palette.grey["50"],
    overflow: "hidden",
    height: "100%"
};
const rightSlotSxProps = {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    background: (theme) => theme.palette.background.paper
};
//# sourceMappingURL=TabbedDialog.js.map